import React from 'react'
import { bool } from 'prop-types'
import { useIntl } from 'gatsby-plugin-intl'

import Button from 'components/button/Button'

const MEWS_BOOKING_URL =
  'https://app.mews.com/distributor/66af42b6-02a5-4ccb-a67e-b27400ec99ec'

const BookButton = ({ isSmall, url, target }) => {
  const intl = useIntl()
  const href = url || MEWS_BOOKING_URL

  const props = {
    theme: 'primary',
    target: target || '_blank',
    href,
    size: isSmall ? 'small' : null,
  }

  return (
    <>
      <Button {...props}>{intl.formatMessage({ id: 'home.bookNow' })}</Button>
    </>
  )
}

BookButton.propTypes = {
  isSmall: bool,
}

export default BookButton
